import React from "react";
import { Link } from "react-router-dom";

import { grey as Grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const commonStyles = {
  main: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  link: {
    boxSizing: "border-box" as const,
    color: Grey["700"],
    display: "inline-block",
    padding: 16,
    textDecoration: "none",
    width: "100%",
  },
  unit: {
    fontSize: 20,
    marginLeft: 4,
  },
};

type Props = {
  label: string;
  to: string;
  value: number | undefined; // 値が読み込み中の場合にundefined
  loading: boolean;
};

export const ItemCount = (props: Props) => {
  const { label, loading, to, value } = props;

  return (
    <Box sx={commonStyles.main}>
      <Link to={to} style={commonStyles.link}>
        <Box display="flex" width={1}>
          <Box flex={1}>
            <Typography color="textSecondary">{label}</Typography>
          </Box>
          <Box flex={1}>
            {loading && (
              <Box textAlign="center" p={1}>
                <CircularProgress size={24} />
              </Box>
            )}
            {!loading && (
              <Typography variant="h4" align="right">
                {value === undefined ? "-" : value.toLocaleString()}
                <Box component="span" sx={commonStyles.unit}>
                  件
                </Box>
              </Typography>
            )}
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
